/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerMiniCartItemSX: SxProps = {
	py: 2,
	'span':{
	display:'flex',
	alignItems:'center',
	justifyContent:'space-between',
	paddingLeft: '5px',
	paddingRight: '5px'
}
};

export const headerMiniCartclosebuttonSX = {
		cursor:'pointer',
		fontSize:'18px', 
		color:'#000000',
};